export var TypeActionTooltip;
(function (TypeActionTooltip) {
    TypeActionTooltip["SetCursor"] = "Tooltip > SetCursor";
    TypeActionTooltip["SetContent"] = "Tooltip > SetContent";
    TypeActionTooltip["Hide"] = "Tooltip > Hide";
    TypeActionTooltip["Show"] = "Tooltip > Show";
    TypeActionTooltip["ShowBuildingTooltipText"] = "Tooltip > ShowBuildingTooltip";
    TypeActionTooltip["HideBuildingTooltipText"] = "Tooltip > HideBuildingTooltip";
})(TypeActionTooltip || (TypeActionTooltip = {}));
export var actionTooltipSetCursor = function (cursor) { return ({
    cursor: cursor,
    type: TypeActionTooltip.SetCursor,
}); };
export var actionTooltipHide = function (targetId) { return ({
    targetId: targetId,
    type: TypeActionTooltip.Hide,
}); };
export var actionTooltipShow = function (targetId) { return ({
    targetId: targetId,
    type: TypeActionTooltip.Show,
}); };
export var actionTooltipShowBuildingText = function (id, position, loca, buildingLevel, replacements) {
    return {
        buildingLevel: buildingLevel,
        id: id,
        loca: loca,
        position: position,
        replacements: replacements,
        type: TypeActionTooltip.ShowBuildingTooltipText,
    };
};
export var actionTooltipHideBuildingText = function (id) { return ({
    id: id,
    type: TypeActionTooltip.HideBuildingTooltipText,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/tooltip/actionTooltip.ts
// module id = 342
// module chunks = 3